<template>
  <ProjectDetails
    hide-adding-new-row
    hide-compare-views
    hide-documents
    hide-find-in-view
    hide-remove-project
    hide-shared-link
    hide-summary-comments
    hide-versions
    is-shared-link />
</template>
<script>
import ProjectDetails from '@/views/ProjectDetails';
export default {
  name: 'WrapperProjectSharedLink',
  components: {
    ProjectDetails,
  },
};
</script>
